
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AnimateInView from '@/components/ui/animate-in-view';

/**
 * TeamNote component that displays a quote from the team with a call-to-action button
 * Creates a visually appealing section with a team quote and contact button
 * @returns {JSX.Element} A section with a team quote and CTA
 */
const TeamNote = () => {
  return <section className="section py-20 bg-gradient-to-r from-background to-accent/30" aria-labelledby="team-note-heading">
      <div className="container mx-auto text-center max-w-3xl">
        <AnimateInView animation="scale-in" delay={100}>
          <div className="bg-white/70 backdrop-blur-md border border-accent/30 rounded-2xl shadow-lg p-8 transform transition-all duration-700 hover:shadow-xl hover:-translate-y-1">
            <div className="h-0.5 bg-gold w-20 mx-auto mb-6"></div>
            <h2 id="team-note-heading" className="mb-6 text-primary">
              Note From the Team
            </h2>
            <blockquote className="text-xl bold text-foreground mb-8">
              "As we navigate an era of escalating security threats, Forti-Fi is redefining proactive defense. Our systems are not just technology, they're a promise to safeguard what matters most."
            </blockquote>
            <div className="mt-8">
              <Button asChild size="lg" variant="gradient" className="text-white font-medium">
                <Link to="/contact">
                  Contact Us Today
                </Link>
              </Button>
            </div>
          </div>
        </AnimateInView>
      </div>
    </section>;
};
export default TeamNote;
